import { Box, Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { ColorValue } from 'react-native';

export const EmojiStat = function EmojiStat({
  emoji,
  color,
  value,
  label,
}: {
  emoji: string;
  color: ColorValue;
  value: string;
  label: string;
}) {
  return (
    <Row flex={1} gap="spacing.general.x2" alignItems="center">
      <Box
        style={{
          height: 38,
          width: 38,
          borderRadius: 19,
          backgroundColor: color,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text fontSize={18} textAlign="center">
          {emoji}
        </Text>
      </Box>
      <Column flex={1} gap="spacing.general.x0,5">
        <Text fontSize={16} fontWeight="700" numberOfLines={1}>
          {value}
        </Text>
        <Text fontSize={12} color="text.tertiary" numberOfLines={2}>
          {label}
        </Text>
      </Column>
    </Row>
  );
};
